import React, { useState } from "react";
import COMPLETED from "../../../assets/images/trip-completed.png";
import { useAppSelector } from "../../../app/hooks";
import INDIGO from "../../../assets/images/INDIGO.png";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { getFlightImage } from "../../../_helpers/flightUtils";
import { FaArrowRightArrowLeft, FaArrowRightLong } from "react-icons/fa6";
import { ErrorToast } from "../../../toast/Toasts";
import { API_URL } from "../../../app/config";
import { getRequestId } from "../../../_helpers/miscUtils";
import { FlightImage } from "../../../components/flightimage/FlightImage";

const CompletedTrips = () => {
  const MytripsList = useAppSelector((state) => state.mytrips.MytripsList);

  const [invoiceLoadingIndexes, setInvoiceLoadingIndexes] = useState<string[]>(
    []
  );

  const navigate = useNavigate();

  const handleDownloadInvoice = async (
    Booking_RefNo: string,
    Airline_PNR: string,
    key: string
  ) => {
    try {
      setInvoiceLoadingIndexes((prev) => {
        if (!prev.includes(key)) {
          return [...prev, key];
        }
        return prev;
      });

      const Request_Id = getRequestId();

      const response = await fetch(
        `${API_URL}/AirlineReprint/Air_ReprintInvoice`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Booking_RefNo,
            Airline_PNR,
            IsPayment: false,
            Request_Id,
          }),
        }
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice-${Airline_PNR}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Invoice! - Please try again later");
    } finally {
      setInvoiceLoadingIndexes((prev) => prev.filter((i) => i !== key));
    }
  };

  return (
    <div
      className="tab-pane fade"
      id="pills-completed-flight"
      role="tabpanel"
      aria-labelledby="pills-completed-flight-tab"
    >
      {MytripsList && MytripsList.completed?.length > 0 ? (
        MytripsList.completed.map((item: any, index: any) => {
          const isOneWayTrip = item?.flight_type === "ONEWAY";

          return (
            <div className="flight-card-wrapper">
              <div className="flight-header">
                <div>
                  <div className="flight-header-wrapper">
                    <h2>
                      {item?.departure_airport}
                      <span className="me-2 ms-2">
                        {isOneWayTrip ? (
                          <FaArrowRightLong />
                        ) : (
                          <FaArrowRightArrowLeft />
                        )}
                      </span>
                      {item?.arrival_airport}
                    </h2>
                    {isOneWayTrip && (
                      <span className="day-badge">Completed</span>
                    )}
                  </div>
                  <p className="flight-status">
                    <strong>
                      {isOneWayTrip ? "One Way Flight" : "Round Trip Flight"}
                    </strong>{" "}
                    • Booking Ref. No. -{" "}
                    <strong>{item?.portal_booking_no}</strong>
                  </p>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/flights/completed-trip-details?bookingId=${item?.portal_booking_no}`
                    );
                  }}
                  className="fill-btn manage-btn"
                >
                  View & Manage Booking
                </button>
              </div>
              <div className="flight-body">
                {!isOneWayTrip && (
                  <div className="w-100 mb-1">
                    <span className="flight-type">Departure Flight</span>
                    <span className="depart-time">
                      {" "}
                      -{" "}
                      {moment(
                        item?.onwardDetails?.departure_date_time,
                        "MM/DD/YYYY HH:mm:ss"
                      ).format("ddd, DD MMM")}
                    </span>
                    <span className="day-badge ms-2">
                      <span className="day-badge">Completed</span>
                    </span>
                  </div>
                )}
                <div className="flight-section">
                  {isOneWayTrip && <p className="label">From</p>}
                  <p className="time">
                    {moment(
                      item?.onwardDetails?.departure_date_time,
                      "MM/DD/YYYY HH:mm:ss"
                    ).format("DD MMM 'YY hh:mm A")}
                  </p>
                  <p className="airport">
                    {item?.onwardDetails?.departure_airport}
                  </p>
                </div>
                <div className="flight-section">
                  {isOneWayTrip && <p className="label">To</p>}
                  <p className="time">
                    {moment(
                      item?.onwardDetails?.arrival_date_time,
                      "MM/DD/YYYY HH:mm:ss"
                    ).format("DD MMM 'YY hh:mm A")}
                  </p>
                  <p className="airport">
                    {item?.onwardDetails?.arrival_airport}
                  </p>
                </div>
                <div className="flight-section airline-passenger">
                  <FlightImage
                    key={item?.onwardDetails?.airline_code}
                    flightCode={item?.onwardDetails?.airline_code}
                    style={{ height: 40, width: 40 }}
                  />
                  <p className="m-0">
                    {item?.onwardDetails?.airline_name}
                    {", "}
                    <strong>{item?.onwardDetails?.flight_no}</strong>
                  </p>
                </div>
                <div className="flight-section last-col">
                  <div className="ticket-list">
                    <li
                      onClick={() =>
                        !invoiceLoadingIndexes?.includes(
                          `${item?.onwardDetails?.pnr}_${index}`
                        ) &&
                        handleDownloadInvoice(
                          item?.portal_booking_no,
                          item?.onwardDetails?.pnr,
                          `${item?.onwardDetails?.pnr}_${index}`
                        )
                      }
                    >
                      <span className="icon">
                        {invoiceLoadingIndexes?.includes(
                          `${item?.onwardDetails?.pnr}_${index}`
                        ) ? (
                          <div
                            className="spinner-border text-primary me-1"
                            role="status"
                            style={{ width: 15, height: 15 }}
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="20"
                            viewBox="0 0 24 24"
                            fill={"#007BFF"}
                          >
                            <path d="M0 0h24v24H0V0z" fill="none" />
                            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18h14v2H5z" />
                          </svg>
                        )}
                      </span>
                      <span
                        style={{
                          color: invoiceLoadingIndexes?.includes(
                            `${item?.onwardDetails?.pnr}_${index}`
                          )
                            ? "#999999"
                            : "#007BFF",
                        }}
                      >
                        Download Invoice(s)
                      </span>
                    </li>
                  </div>
                </div>
              </div>
              {item?.returnDetails && (
                <div className="flight-body pt-0">
                  {!isOneWayTrip && (
                    <div className="w-100 mb-1">
                      <span className="flight-type">Return Flight</span>
                      <span className="depart-time">
                        {" "}
                        -{" "}
                        {moment(
                          item?.returnDetails?.departure_date_time,
                          "MM/DD/YYYY HH:mm:ss"
                        ).format("ddd, DD MMM")}
                      </span>
                      <span className="day-badge ms-2">Completed</span>
                    </div>
                  )}
                  <div className="flight-section">
                    {isOneWayTrip && <p className="label">From</p>}
                    <p className="time">
                      {moment(
                        item?.returnDetails?.departure_date_time,
                        "MM/DD/YYYY HH:mm:ss"
                      ).format("DD MMM 'YY hh:mm A")}
                    </p>
                    <p className="airport">
                      {item?.returnDetails?.departure_airport}
                    </p>
                  </div>
                  <div className="flight-section">
                    {isOneWayTrip && <p className="label">To</p>}
                    <p className="time">
                      {moment(
                        item?.returnDetails?.arrival_date_time,
                        "MM/DD/YYYY HH:mm:ss"
                      ).format("DD MMM 'YY hh:mm A")}
                    </p>
                    <p className="airport">
                      {item?.returnDetails?.arrival_airport}
                    </p>
                  </div>
                  <div className="flight-section airline-passenger">
                    <FlightImage
                      key={item?.returnDetails?.airline_code}
                      flightCode={item?.returnDetails?.airline_code}
                      style={{ height: 40, width: 40 }}
                    />
                    <p className="m-0">
                      {item?.returnDetails?.airline_name}
                      {", "}
                      <strong>{item?.returnDetails?.flight_no}</strong>
                    </p>
                  </div>
                  <div className="flight-section last-col">
                    <div className="ticket-list">
                      <li
                        onClick={() =>
                          !invoiceLoadingIndexes?.includes(
                            `${item?.returnDetails?.pnr}_${index}`
                          ) &&
                          handleDownloadInvoice(
                            item?.portal_booking_no,
                            item?.returnDetails?.pnr,
                            `${item?.returnDetails?.pnr}_${index}`
                          )
                        }
                      >
                        <span className="icon">
                          {invoiceLoadingIndexes?.includes(
                            `${item?.returnDetails?.pnr}_${index}`
                          ) ? (
                            <div
                              className="spinner-border text-primary me-1"
                              role="status"
                              style={{ width: 15, height: 15 }}
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="20"
                              viewBox="0 0 24 24"
                              fill={"#007BFF"}
                            >
                              <path d="M0 0h24v24H0V0z" fill="none" />
                              <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18h14v2H5z" />
                            </svg>
                          )}
                        </span>
                        <span
                          style={{
                            color: invoiceLoadingIndexes?.includes(
                              `${item?.returnDetails?.pnr}_${index}`
                            )
                              ? "#999999"
                              : "#007BFF",
                          }}
                        >
                          Download Invoice(s)
                        </span>
                      </li>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="upcoming-trips">
          <img src={COMPLETED} alt="completed-trips" />
          <h3>Looks empty, you've no completed Trips.</h3>
          <p>When you complete a trip, you will see your itinerary here.</p>
          <Link className="fill-btn" to="/">
            Plan a Trip
          </Link>
        </div>
      )}
    </div>
  );
};

export default CompletedTrips;
